export default function Header() {
  return (
    <header id="Header" className="header">
        <div className="header-inner">
        <h1 className="header-title">WISH LIST</h1>
        <p className="header-text">自分の気持ちに正直に、自由に書き出してみよう。<br />達成したらチェックを入れよう。</p>
        </div>
    </header>
  );
}
